import axios from 'axios'
import QueryParamsUtil from 'api/utils/query-params-util'

const API_PATH = 'api/v2/admins/merchants/contracts'

const MerchantContractApiV2 = {
  /**
   * Get list of `Merchant Contract`
   * @param {object} params uri parameter
   * @return {object} Collection of `Merchant Contract`
   */
  get: async ({ tableState, additionalFilters }) => {
    const params = QueryParamsUtil.format(tableState, additionalFilters)
    const path   = API_PATH

    const response = axios.get(path, { params })
    return response
  }
}

export default MerchantContractApiV2
